import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";

// Define a type for the slice state

interface countriesType {
  id: number;
  sortname: string;
  name: string;
  phonecode: number;
}
// Define the initial state using that type

const getCountriesSlice = createSlice({
  name: "countriesSlcie",

  initialState: [],
  reducers: {
    setAllCountries: <countriesType>(
      state: countriesType,
      action: PayloadAction<countriesType>
    ) => {
      const payload = action.payload;
      state = payload;
    },
    resetAllCountries: (state: any) => {
      state = [];
    },
  },
});

export const { setAllCountries, resetAllCountries } = getCountriesSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default getCountriesSlice.reducer;
